import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { BoxService } from '../box.service';

declare const Box: any;

@Component({
  selector: 'app-box-viewer',
  templateUrl: './box.viewer.component.html',
  styleUrls: ['./box.viewer.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class BoxViewerComponent implements AfterViewInit {
  @Input() folderId: string;
  @Input() options: any = {};
  @Output() onUploadCountChanges = new EventEmitter<number>();

  _uploading = 0;
  get uploading() {
    return this._uploading;
  }
  set uploading(value) {
    this._uploading = value;
    this.onUploadCountChanges.emit(value);
  }

  constructor(
    private el: ElementRef,
    private boxService: BoxService,
  ) {}

  async ngAfterViewInit() {
    const contentExplorer = new Box.ContentExplorer();
    contentExplorer.on('upload', data => {
      this.uploading -= data.length;
    });

    contentExplorer.show(this.folderId, await this.boxService.getToken(), {
      container: this.el.nativeElement.querySelector('.viewer'),
      canCreateNewFolder: false,
      canDelete: true,
      canRename: true,
      canShare: false,
      canSetShareAccess: false,
      logoUrl: '',
      requestInterceptor: request => {
        if (request.method.toLowerCase() == 'post' && request.url.includes('https://upload.')) {
          this.uploading++;
        }
        return request;
      },
      ...this.options,
    });
  }
}
